module.exports = __webpack_public_path__ + "img/titleimg3.0a24e211.png";